import React from 'react'
import {Trans} from 'react-i18next'

import {Box, Typography} from '@mui/material'
import {t} from 'i18next'

import AppointmentCard from '@progyny/pages/Consultations/components/AppointmentCard'
import {
  formatAppointmentDate,
  formatAppointmentTime,
} from '@progyny/utils/appointmentHelpers'

export interface SessionItem {
  sessionIndex: string
  title: string
  subtitle: string
  description: string
  status: string
  appointment: any
  required: boolean
}

/** Minimal shape for past appointment (query may return a subset of AppointmentType) */
export interface PastAppointmentItem {
  scheduledTime?: string | null
  programEnrollment?: {
    program?: {
      sessions?: Array<{title?: string | null} | null> | null
      description?: string | null
    } | null
  } | null
  [key: string]: unknown
}

export interface PastSessionsProps {
  appointments?: PastAppointmentItem[] | null
  sessions?: SessionItem[]
  colors?: any
  className?: string
}

const PastSessions: React.FC<PastSessionsProps> = ({
  sessions,
  appointments,
  colors,
  className,
}) => {
  if (sessions?.length === 0) {
    return (
      <Box className={className}>
        <Typography>
          <Trans i18nKey='consultations_program_past_sessions_no_past_sessions' />
        </Typography>
      </Box>
    )
  }

  return (
    <Box className={className}>
      {sessions?.length &&
        sessions.map((session, index) => (
          <AppointmentCard
            key={index}
            status='completed'
            session={`${t('common_session')} ${session.sessionIndex}`}
            title={session.title}
            subtitle={session.subtitle || ''}
            date={formatAppointmentDate(session.appointment?.scheduledTime)}
            time={formatAppointmentTime(session.appointment?.scheduledTime)}
            description={session.description}
            colors={colors}
          />
        ))}

      {appointments?.length &&
        appointments.map((appointment, index) => (
          <AppointmentCard
            key={index}
            status='completed'
            title={
              appointment.programEnrollment?.program?.sessions?.[0]?.title ??
              undefined
            }
            description={
              appointment.programEnrollment?.program?.description ?? undefined
            }
            date={formatAppointmentDate(appointment.scheduledTime)}
            time={formatAppointmentTime(appointment.scheduledTime)}
            colors={colors}
          />
        ))}
    </Box>
  )
}

export default PastSessions
